import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/settings/givenwell-terms")({
  component: lazyRouteComponent(() => import("./+GivenwellTerms")),
  head: () => ({ meta: seo({ title: "Givenwell Terms" }) }),
});
